import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { SmsTemplate } from 'src/app/models/server/sms-template';
import { Results } from '../../models/server/core/results-T';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class SmsTemplatesService extends ServiceBase {
    /**
     * Constructeur
     * */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Retourne la liste des modèles de SMS d'une vue ainsi que les modèles de SMS commun de l'organisation.
     * @param viewId Id de la vue.
     * @returns liste des modèles de SMS.
     */
    List(viewId: number): Observable<SmsTemplate[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(null),
                filters: this.getHeader(null),
                context: this.getHeader(null),
            }),
        };

        let request = new Array<Observable<SmsTemplate[]>>();

        request.push(
            this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<SmsTemplate>(SmsTemplate, x);
                    return res.value;
                })
            )
        );

        request.push(
            this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/smstemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<SmsTemplate>(SmsTemplate, x);
                    return res.value;
                })
            )
        );

        return forkJoin(request).pipe(
            map((responses) => {
                return [].concat(...responses);
            })
        );
    }

    get(smsTemplateId: number, folderId: string): Observable<SmsTemplate> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params: new HttpParams().set(HttpParamNames.FOLDER_ID, folderId),
        };

        // Appel de la Web Api
        return this.http.get<SmsTemplate>(this.baseUrl + `/api/organizations/${this.organizationId}/smstemplates/${smsTemplateId}`, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
